import { ReactNode, useMemo } from 'react';
import { useGlobalComponentForAttribute } from '@rhino-project/core/hooks';
import { useModelAndAttributeFromPath } from '@rhino-project/core/hooks';
import { RhinoResourceSpecifier } from '@rhino-project/core';
import { Footer } from '../table/Footer';

export interface ModelFooterProps {
  model: RhinoResourceSpecifier;
  path: string;
  children?: ReactNode;
  [key: string]: unknown;
}

export const ModelFooterBase = ({
  model,
  path,
  children,
  ...props
}: ModelFooterProps) => {
  const { attribute } = useModelAndAttributeFromPath(model, path);
  const footerText = useMemo(
    () => children || attribute?.readableName,
    [children, attribute]
  );

  return <Footer {...props}>{footerText}</Footer>;
};

export const ModelFooter = (props: ModelFooterProps) =>
  useGlobalComponentForAttribute('ModelFooter', ModelFooterBase, props);
